import { scroller } from 'react-scroll'
import { ArrowCta } from '@mc/certificates-design-system'
import { StyledVariable } from '@mc/feature-variables'
import { useTranslation } from '@mc/i18n'
import { TITLE_ID } from 'pages/certificates/components/MarketingHubPage'
import { HeroVideo } from 'pages/certificates/components/MarketingHubPage/HeroSection/HeroVideo'
import { LogoSection } from 'pages/certificates/components/common/LogoSection'
import { HubHeroSubsNote } from 'pages/certificates/experiments/mccerts-2624_v1_hub_subs_row'
import { TrackClick, TrackingAttributes } from 'pages/certificates/tracking'
import { HUB_HERO_VIDEO } from '../constants'
import { useMccerts2805Variables } from '../hooks/useMccerts2805Variables'

// Mirrors the original HeroSection markup; the only change is headline/subhead
// coming from GB.
export const HeroSectionVariant = () => {
  const { t } = useTranslation('@mc/certificates')
  const variables = useMccerts2805Variables()

  return (
    <TrackingAttributes location='hero'>
      <section aria-labelledby={TITLE_ID}>
        <div className='container flex flex-col lg:flex-row items-center justify-between pt-6 pb-8 gap-8'>
          <div className='flex flex-col items-center lg:items-start gap-6 flex-[5]'>
            <LogoSection />
            <div className='text-center lg:text-left'>
              <h1 className='text-c-beige-1300 lg:max-w-[17ch] c-d-1 mb-5'>
                <StyledVariable
                  text={variables?.headline}
                  defaultCopy={t('marketingPages.hub.hero.title')}
                />
              </h1>

              <p className='text-c-text-tint-3 c-body-xlarge'>
                {variables?.subhead || t('marketingPages.hub.hero.description')}
              </p>
            </div>

            <TrackClick event='certificateLandingClick'>
              <ArrowCta
                onClick={() =>
                  scroller.scrollTo('browse-certificates', { duration: 250 })
                }
              >
                {t('marketingPages.hub.hero.cta')}
              </ArrowCta>
            </TrackClick>
            <HubHeroSubsNote />
          </div>

          <HeroVideo
            mediaUuid={HUB_HERO_VIDEO.mediaUuid}
            fallbackImageUrl={HUB_HERO_VIDEO.fallbackImageUrl}
            fullWidth
          />
        </div>
      </section>
    </TrackingAttributes>
  )
}
